import React, {useState,useRef} from 'react'
import Menu from './menu'
import {localestr} from '../utils'
import icon from '../icons.svg'; 

function Discount({value,setValue,setModal,data,fld=[]}){
    const [val1, setVal1] = useState('') 
    const [val2, setVal2] = useState(value||'') 
    //const [cnt, setCnt] = useState(0) 
    const targetRef = useRef()

    //console.log(data)
    
    const newVal=(v)=>{
        let vl=val1+v
        if(v===-1) vl=(''+val1).substring(0,(''+val1).length-1)||''
        let vl2=''
        if (vl.length>3){
            if (data) {
                let newVal=data.find(el=>el.phone===vl||el.code===vl)
                if (newVal) {vl2={...newVal};vl=''}
            }
        }
        setVal1(vl)
        setVal2(vl2)
    }

    const newKey=(e)=>{
        let vl=''
        let vl2=''
        //if (vl.length>9){
        if(e.key==='Enter'){
            //console.log(val1)
            if(!val1) setValue(val2||'-1')
            else if (data) {
                let newVal=data.find(el=>el.phone===val1||el.code===val1)
                if (newVal) {setValue(vl2={...newVal})}
            }
            setModal('')
        } else vl=(val1+e.key).replace('Shift/','?').replace('?Shift','?')
        //console.log(vl)
        setVal1(vl)
        setVal2(vl2)
    }

    const setFocus=(el)=>{
        if (!el) return
        el.focus()
    }

    const dsc=data.filter(el=>{
        if(parseInt(el.canUse)===0) return false
        if(!el.pid) return true
        let parrent=fld.find(it=>it.id===el.pid)
        if(parrent&&parrent.marked) return false
        return true
    })
    dsc.sort((a,b)=>{
        let ret=0
        if(a.pid && b.pid){
            let a1=fld.find(el=>el.id===a.pid)||{name:''}
            let b1=fld.find(el=>el.id===b.pid)||{name:''}
            if(a1.name>b1.name) ret=1
            else if(a1.name<b1.name) ret=-1
            else if(a1.id!==b1.id) ret=parseInt(a1.id)-parseInt(b1.id)
            else if(a.name>b.name) ret=1
            else if(a.name<b.name) ret=-1
        }
        else if(a.pid) ret=-1
        else if(b.pid) ret=1
        else if(a.name>b.name) ret=1
        else if(a.name<b.name) ret=-1
        return ret
    })
    //console.log(dsc)
    //const lst=dsc.map(el=>({name:el.name+' '+(el.prc||0)+'%',action:()=>{setVal1('');setVal2(el)}}))
    const lst=[]
    let last=null
    for(let i=0;i<dsc.length;i++){
        const it=dsc[i]
        let it_name=it.name.substring(0,20)
        if(it.type===0 && it.prc) it_name=it_name+' '+it.prc+'%'
        if(it.pid){
            if(it.pid!==last){
                last=it.pid
                // eslint-disable-next-line
                let parrent=fld.find(e=>e.id===last)
                if(parrent) lst.push({name:parrent.name.substring(0,30),icon:-1,isFolder:true,id:last})
            }
            lst.push({name:it_name,action:()=>{setVal1('');setVal2(it)},icon:-1,parent:last})
        } else lst.push({name:it_name,action:()=>{setVal1('');setVal2(it)},icon:-1})
    }
    //console.log(lst)

    let desc=localestr('Відскануйте картку,\nвведіть номер телефона\nабо виберіть знижку із\nвипадного списку')
    let desc2='0.00'
    if (val2) {
        if(val2?.type===2) desc=<b>{val2.name+'\n'+localestr('Знижка ')+parseFloat(val2.prc||0)+localestr(' в місяць')}</b>
        else if(val2?.type===1) desc=<b>{val2.name+'\n'+localestr('Бонусна картка ')+parseFloat(val2.prc||0)+'%'}</b>
        else desc=<b>{val2.name+'\n'+localestr('Знижка ')+parseFloat(val2.prc||0)+'%'}</b>
        if(val2?.type) desc2=parseFloat(val2.balance||0).toFixed(2)
    }

    //const stl={margin:'2px 4px',width:'54px'}
    const stl={margin:'4px',width:'48px'}
    const stl2={height:'48px',lineHeight:'48px'}

    if(!val2||!val2?.type) return(
        <div className='modal'><div className='window'>
            <div style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{localestr('Знижка')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content' style={{overflow:'visible'}}>
            <div style={{whiteSpace:'pre'}}>
                {desc}
            </div>
            <div style={{height:'24px',margin:'5px 0 0 0',fontSize:'larger',fontWeight:'bold',display:'flex',justifyContent:'flex-end',padding: '5px',border:'solid 2px #0006', borderRadius:'6px'}}>
                <div tabIndex='0' style={{flexGrow:'30',outline:'none'}} ref={el=>{setFocus(el);return targetRef}} onKeyUp={(e)=>{newKey(e)}}>{val1}</div>
                <Menu data={lst}><div style={{margin:'-2px -4px 0 0',width:'28px'}}><img style={{width:'28px',height:'28px'}} src={icon+'#v_menu'} alt='' /></div></Menu>
            </div>
            <div style={{margin:'10px 0 0 0',display:'flex',flexDirection:'column',justifyContent:'center',flexWrap:'wrap'}}>
                <div style={{flexDirection:'row',display:'flex',justifyContent:'center'}}>
                    <div style={stl} className={'login_btn'} onClick={()=>{newVal('1')}}><div style={stl2}>1</div></div>
                    <div style={stl} className={'login_btn'} onClick={()=>{newVal('2')}}><div style={stl2}>2</div></div>
                    <div style={stl} className={'login_btn'} onClick={()=>{newVal('3')}}><div style={stl2}>3</div></div>
                    <div style={{margin:'0px',background:'none',border:'none'}} className='login_btn' title={localestr('Стерти')} onClick={()=>{newVal(-1)}}><div><img style={{width:'24px',height:'24px'}} src={icon+'#key_b'} alt='' /></div></div>
                </div><div style={{flexDirection:'row',display:'flex',justifyContent:'center'}}>
                    <div style={stl} className={'login_btn'} onClick={()=>{newVal('4')}}><div style={stl2}>4</div></div>
                    <div style={stl} className={'login_btn'} onClick={()=>{newVal('5')}}><div style={stl2}>5</div></div>
                    <div style={stl} className={'login_btn'} onClick={()=>{newVal('6')}}><div style={stl2}>6</div></div>
                    <div style={{margin:'0px',background:'none',border:'none'}} className='login_btn' title={localestr('Стерти')} onClick={()=>{setVal1('');setVal2('')}}><div><img style={{width:'18px',height:'18px'}} src={icon+'#calcx'} alt='' /></div></div>
                </div><div style={{flexDirection:'row',display:'flex',justifyContent:'center'}}>
                    <div style={stl} className={'login_btn'} onClick={()=>{newVal('7')}}><div style={stl2}>7</div></div>
                    <div style={stl} className={'login_btn'} onClick={()=>{newVal('8')}}><div style={stl2}>8</div></div>
                    <div style={stl} className={'login_btn'} onClick={()=>{newVal('9')}}><div style={stl2}>9</div></div>
                    <div style={{margin:'0px',background:'none',border:'none'}} className='login_btn'></div>
                </div><div style={{flexDirection:'row',display:'flex',justifyContent:'center'}}>
                    <div style={{margin:'0px',background:'none',border:'none'}} className='login_btn'></div>
                    <div style={stl} className={'login_btn'} onClick={()=>{newVal('0')}}><div style={stl2}>0</div></div>
                    <div className='ord_button2 toolBarItem2' title={localestr('OK')} onClick={()=>{setValue(val2||'-1');setModal('')}} style={{width:'84px',height:'39px',lineHeight:'32px',margin:'12px 4px 4px 28px'}}>
                        {localestr('OK')}</div>
                </div>
            </div></div>
        </div></div>
    )

    if(val2?.type===1) return(
        <div className='modal'><div className='window'>
            <div style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{localestr('Бонусна картка')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content' style={{overflow:'visible'}}>
            <div style={{margin:'10px 0 0 0',display:'flex',flexDirection:'column',justifyContent:'center',flexWrap:'wrap'}}>
                <div style={{flexDirection:'row',display:'flex',justifyContent:'center',height:'100px'}}>
                    <div style={{whiteSpace:'pre',width:'168px',marginLeft:'4px'}}>{desc}</div>
                    <div style={{margin:'0px',background:'none',border:'none'}} className='login_btn' title={localestr('Стерти')} onClick={()=>{newVal(-1)}}><div><img style={{width:'24px',height:'24px'}} src={icon+'#key_b'} alt='' /></div></div>
                </div>
                <div style={{flexDirection:'row',display:'flex',justifyContent:'center',height:'60px',fontSize:'36pt',fontWeight:'bolder',color:'#088'}}>{desc2}</div>
                <div style={{flexDirection:'row',display:'flex',justifyContent:'center',height:'100px',color:'#088'}}>{localestr('Доступно для списання')}</div>
                
                <div style={{flexDirection:'row',display:'flex',justifyContent:'center'}}>
                    <div className='ord_button2 toolBarItem2' title={localestr('Списати бонус')} onClick={()=>{setValue({...val2,use:true});setModal('')}} style={{width:'136px',height:'39px',lineHeight:'32px',margin:'12px 4px 4px 4px'}}>
                        {localestr('Списати бонус')}</div>
                    <div className='ord_button2 toolBarItem2' title={localestr('OK')} onClick={()=>{setValue(val2||'-1');setModal('')}} style={{width:'84px',height:'39px',lineHeight:'32px',margin:'12px 4px 4px 2px'}}>
                        {localestr('OK')}</div>
                </div>
            </div></div>
        </div></div>
    )

    return(
        <div className='modal'><div className='window'>
            <div style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{localestr('Знижка')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content' style={{overflow:'visible'}}>
            <div style={{margin:'10px 0 0 0',display:'flex',flexDirection:'column',justifyContent:'center',flexWrap:'wrap'}}>
                <div style={{flexDirection:'row',display:'flex',justifyContent:'center',height:'100px'}}>
                    <div style={{whiteSpace:'pre',width:'168px',marginLeft:'4px'}}>{desc}</div>
                    <div style={{margin:'0px',background:'none',border:'none'}} className='login_btn' title={localestr('Стерти')} onClick={()=>{newVal(-1)}}><div><img style={{width:'24px',height:'24px'}} src={icon+'#key_b'} alt='' /></div></div>
                </div>
                <div style={{flexDirection:'row',display:'flex',justifyContent:'center',height:'60px',fontSize:'36pt',fontWeight:'bolder',color:'#088'}}>{desc2}</div>
                <div style={{flexDirection:'row',display:'flex',justifyContent:'center',height:'100px',color:'#088'}}>{localestr('Доступно для списання')}</div>
                <div style={{flexDirection:'row',display:'flex',justifyContent:'center'}}>
                    <div style={{margin:'0px',background:'none',border:'none'}} className='login_btn'></div>
                    <div style={{margin:'0px',background:'none',border:'none'}} className='login_btn'></div>
                    <div className='ord_button2 toolBarItem2' title={localestr('OK')} onClick={()=>{setValue(val2||'-1');setModal('')}} style={{width:'84px',height:'39px',lineHeight:'32px',margin:'12px 4px 4px 26px'}}>
                        {localestr('OK')}</div>
                </div>
            </div></div>
        </div></div>
    )
}

export default Discount